import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-140f531c")

_pushScopeId("data-v-140f531c")
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "新增合同",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.visible = $event)),
    width: "600px",
    onClosed: _ctx.onClosed
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.formData,
        "label-width": "130px",
        style: {"max-width":"600px"}
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "所属公司:",
            prop: "companyUuid"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.companyUuid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.companyUuid = $event)),
                "remote-method": _ctx.remoteData1.remoteMethod,
                remote: "",
                placeholder: "请输入",
                clearable: "",
                filterable: "",
                style: {"width":"200px"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.remoteData1.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "业务类型:",
            prop: "businessType"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.businessType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.businessType = $event)),
                placeholder: "请选择",
                style: {"width":"200px"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "备案",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "转移",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "查看违章",
                    value: 3
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "名额数量:",
            prop: "quota"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.formData.quota,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.quota = $event)),
                min: 1,
                step: 1,
                precision: 0,
                "step-strictly": "",
                "controls-position": "right",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "单价（元/辆/天）:",
            prop: "unitPrice"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.formData.unitPrice,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.unitPrice = $event)),
                min: 0,
                precision: 2,
                "controls-position": "right",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "批次金额（元）:",
            prop: "totalAmount"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.formData.totalAmount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.totalAmount = $event)),
                min: 0,
                precision: 2,
                "controls-position": "right",
                style: {"width":"200px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "计费周期:",
            prop: "billingCycle"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.billingCycle,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.billingCycle = $event)),
                placeholder: "请选择",
                clearable: "",
                style: {"width":"200px"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "月付",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "季付",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "年付",
                    value: 3
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "付款方式:",
            prop: "payType"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.payType,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.payType = $event)),
                placeholder: "请选择",
                clearable: "",
                style: {"width":"200px"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "一次性",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "分期",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "先用后付",
                    value: 3
                  }),
                  _createVNode(_component_el_option, {
                    label: "赠送",
                    value: 4
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "批次起始:",
            prop: "startTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.startTime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.startTime = $event)),
                type: "date",
                placeholder: "不选则录入即生效",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD 00:00:00"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "批次到期:",
            prop: "expireTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.expireTime,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.expireTime = $event)),
                type: "date",
                placeholder: "请选择",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD 23:59:59"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "数据查询范围时间:",
            prop: "dataScopeTime"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.dataScopeTime,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.dataScopeTime = $event)),
                type: "date",
                placeholder: "请选择",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD 00:00:00"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "备注:",
            prop: "remark"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.remark,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.remark = $event)),
                type: "textarea",
                maxlength: 255,
                "show-word-limit": "",
                placeholder: "请输入",
                clearable: "",
                rows: 3
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
})